/*
 * Tencent is pleased to support the open source community by making
 * 蓝鲸智云PaaS平台 (BlueKing PaaS) available.
 *
 * Copyright (C) 2021 THL A29 Limited, a Tencent company.  All rights reserved.
 *
 * 蓝鲸智云PaaS平台 (BlueKing PaaS) is licensed under the MIT License.
 *
 * License for 蓝鲸智云PaaS平台 (BlueKing PaaS):
 *
 * ---------------------------------------------------
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
 * documentation files (the "Software"), to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and
 * to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of
 * the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO
 * THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF
 * CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 */

import { h } from 'vue';

import { commonSVGProps } from '../common/icon';

/**
 * 文档图标
 */
export const DocumentIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-document-icon': true,
    },
  },
  [
    h('g', { fill: 'none' }, [
      h('path', {
        fill: '#3D4265',
        d: 'M708.9230754909091 157.53846132363637L984.6153867636364 157.53846132363637C1006.3669061818182 157.53846132363637 1024 175.17155421090908 1024 196.9230764218182L1024 945.2307688727273C1024 988.7338123636364 988.7338123636364 1024 945.2307688727273 1024L708.9230754909091 1024 708.9230754909091 157.53846132363637Z',
      }),
      h('path', {
        fill: '#3A84FF',
        d: 'M0 984.6153867636364C0 995.0608337454545 4.149438594327273 1005.0784674909091 11.535486650181818 1012.4645143272728 18.921534743272726 1019.8505611636365 28.939165649454548 1024 39.38461500509091 1024L945.2307688727273 1024C901.7277253818182 1024 866.4615377454545 988.7338123636364 866.4615377454545 945.2307688727273L866.4615377454545 39.384615051636366C866.4615377454545 17.633092747636365 848.8284439272727 0 827.0769245090909 0L39.38461500509091 0C17.633092747636365 0 0 17.633092747636365 0 39.384615051636366L0 984.6153867636364Z',
      }),
      h('path', {
        fill: '#FFF',
        d: 'M196.92307688727274 288.82051304727275C175.17155467636363 288.82051304727275 157.53846132363637 306.45360593454546 157.53846132363637 328.2051281454546 157.53846132363637 349.9566508218182 175.17155467636363 367.5897437090909 196.92307688727274 367.5897437090909L354.4615391418182 367.5897437090909C376.2130618181818 367.5897437090909 393.8461547054545 349.9566508218182 393.8461547054545 328.2051281454546 393.8461547054545 306.45360593454546 376.2130618181818 288.82051304727275 354.4615391418182 288.82051304727275L196.92307688727274 288.82051304727275ZM196.92307688727274 525.1282059636363C175.17155467636363 525.1282059636363 157.53846132363637 542.7612997818183 157.53846132363637 564.5128192000001 157.53846132363637 586.2643432727273 175.17155467636363 603.8974370909091 196.92307688727274 603.8974370909091L669.5384622545455 603.8974370909091C691.2899816727273 603.8974370909091 708.9230754909091 586.2643432727273 708.9230754909091 564.5128192000001 708.9230754909091 542.7612997818183 691.2899816727273 525.1282059636363 669.5384622545455 525.1282059636363L196.92307688727274 525.1282059636363ZM196.92307688727274 761.4358993454546C175.17155467636363 761.4358993454546 157.53846132363637 779.0689885090909 157.53846132363637 800.8205125818182 157.53846132363637 822.5720366545454 175.17155467636363 840.2051304727273 196.92307688727274 840.2051304727273L433.23076933818186 840.2051304727273C454.9822915490909 840.2051304727273 472.61538676363637 822.5720366545454 472.61538676363637 800.8205125818182 472.61538676363637 779.0689885090909 454.9822915490909 761.4358993454546 433.23076933818186 761.4358993454546L196.92307688727274 761.4358993454546Z',
      }),
    ]),
  ],
);
export const PreviewIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-preview-icon': true,
    },
  },
  [
    h('path', {
      fillRule: 'evenodd',
      d: 'M512 192C759.4 192 960 335.3 960 512 960 688.7 759.4 832 512 832 264.6 832 64 688.7 64 512 64 335.3 264.6 192 512 192ZM512 256C457.8 256 405.4 263.5 356.1 278.4 309.5 292.5 267.8 312.5 232.4 337.8 165.1 385.9 128 447.8 128 512 128 576.2 165.1 638.1 232.4 686.2 267.8 711.5 309.5 731.5 356.1 745.6 405.4 760.5 457.8 768 512 768 566.2 768 618.6 760.5 667.9 745.6 714.5 731.5 756.2 711.5 791.6 686.2 858.9 638.1 896 576.2 896 512 896 447.8 858.9 385.9 791.6 337.8 756.2 312.5 714.5 292.5 667.9 278.4 618.6 263.5 566.2 256 512 256ZM512 352C600.4 352 672 423.6 672 512 672 600.4 600.4 672 512 672 423.6 672 352 600.4 352 512 352 423.6 423.6 352 512 352ZM512 416C459.1 416 416 459.1 416 512 416 564.9 459.1 608 512 608 564.9 608 608 564.9 608 512 608 459.1 564.9 416 512 416Z',
    }),
  ],
);
export const TargetIcon = h(
  'svg',
  {
    ...commonSVGProps,
    viewBox: '0 0 64 64',
    class: {
      [commonSVGProps.class]: true,
      'ai-target-icon': true,
    },
  },
  [
    h('g', null, [
      h('path', {
        d: 'M54 8H31v4h18.2L22.6 38.6l2.8 2.8L52 14.8V33h4V10c0-1.1-.9-2-2-2z',
      }),
      h('path', {
        d: 'M52 44v8H12V12h7.9V8H10c-1.1 0-2 .9-2 2v44c0 1.1.9 2 2 2h44c1.1 0 2-.9 2-2V44h-4z',
      }),
    ]),
  ],
);
export const RemoveIcon = h(
  'svg',
  {
    ...commonSVGProps,
    viewBox: '0 0 64 64',
    class: {
      [commonSVGProps.class]: true,
      'ai-remove-icon': true,
    },
  },
  [
    h('path', {
      fill: '#737987',
      d: 'M32,4C16.5,4,4,16.5,4,32s12.5,28,28,28s28-12.5,28-28S47.5,4,32,4z M43.3,40.5l-2.8,2.8L32,34.8l-8.5,8.5l-2.8-2.8l8.5-8.5l-8.5-8.5l2.8-2.8l8.5,8.5l8.5-8.5l2.8,2.8L34.8,32L43.3,40.5z',
    }),
  ],
);
export const ArrowRightIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-arrow-right-icon': true,
    },
  },
  [
    h('path', {
      d: 'M822.3999999999999 493.43999999999994l-439.03999999999996-356.48c-10.239999999999998-8.32-26.24-10.879999999999999-40.31999999999999-7.04s-23.04 14.08-23.04 25.599999999999998v712.96c0 11.52 8.959999999999999 21.119999999999997 23.04 25.599999999999998 4.4799999999999995 1.2799999999999998 8.959999999999999 1.92 13.44 1.92 10.239999999999998 0 19.84-3.1999999999999997 26.88-8.959999999999999l439.03999999999996-356.48c12.799999999999999-10.239999999999998 12.799999999999999-26.88 0-37.12z',
    }),
  ],
);
export const LinkIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-link-icon': true,
    },
  },
  [
    h('path', {
      d: 'M263.04 760.96a148.48 148.48 0 0 1-1.92-224l92.48-92.48L308.48 398.72 216 491.2a212.8 212.8 0 0 0 1.92 314.88 212.8 212.8 0 0 0 314.88 1.92l92.48-92.48L579.84 672l-92.48 92.48A148.48 148.48 0 0 1 263.04 760.96Z',
    }),
    h('path', {
      d: 'M491.2 216L398.72 308.48l45.44 45.12 92.48-92.48a148.48 148.48 0 0 1 224 1.92 148.48 148.48 0 0 1 1.92 224L672 579.84l45.12 45.44 92.48-92.48a212.8 212.8 0 0 0-1.92-314.88A212.8 212.8 0 0 0 491.2 216Z',
    }),
    h('path', {
      d: 'M398.78566017615634 579.8877413259167L579.8049961599127 398.86840534216054 625.0598301558516 444.1232393380996 444.0404941720955 625.1425753218557 398.78566017615634 579.8877413259167z',
    }),
  ],
);
/**
 * 图片加载失败图标
 */
export const ImageErrorIcon = h(
  'svg',
  {
    ...commonSVGProps,
    viewBox: '0 0 24 18',
    class: {
      [commonSVGProps.class]: true,
      'ai-image-error-icon': true,
    },
  },
  [
    h('path', {
      d: 'M8.018 0l-.774 2.941.856 2.206-.757 1.47 1.26-1.272-.232-2.224 1.102-3.088h7.228c1.322.01 2.388 1.085 2.39 2.408v5.196a5.42 5.42 0 0 0-1.186.144V2.46c-.035-.645-.542-1.164-1.186-1.213H10.346L9.388 3.04l-.18 2.573-2.636 2.261.859-2.629-1.186-2.006.18-1.978H2.57c-.334-.01-.658.115-.9.346a1.24 1.24 0 0 0-.385.885L1.252 13.07l3.921-4.834c.477-.481 1.068-.481 1.436 0l3.44 4.47 3.344-3.375c.194-.242.495-.372.804-.349.309.024.586.198.742.467l.171.221a5.45 5.45 0 0 0-.928 2.874c0 1.896 1.074 3.54 2.648 4.359l-.122.005H2.39C1.065 16.877.017 15.776.048 14.45L0 2.393C.044 1.071 1.131.024 2.452.033h5.566zM19.09 8.25a4.295 4.295 0 1 1 0 8.591 4.295 4.295 0 0 1 0-8.591zm0 5.83a.46.46 0 1 0 0 .92.46.46 0 0 0 0-.92zm0-3.936a.434.434 0 0 0-.433.408l.126 2.915a.307.307 0 0 0 .614 0l.122-2.822a.434.434 0 0 0-.43-.5zm-5.405-5.737a2.03 2.03 0 0 1 .95 1.653 2.03 2.03 0 0 1-.95 1.653 1.93 1.93 0 0 1-1.918 0 2.03 2.03 0 0 1-.95-1.653c.004-.678.364-1.304.95-1.653a1.93 1.93 0 0 1 1.918 0z',
      fill: 'currentColor',
      'fill-rule': 'nonzero',
    }),
  ],
);
